module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-top-header sticky-tab",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pageStickyHeaderXXX"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "card-label"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card card-label"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0.6em",
      "margin-top": "-2em"
    }
  }, [_c('div', {
    staticClass: "card-arm-line"
  }, [_c('p', {
    staticStyle: {
      "padding-top": "9px"
    }
  }, [_c('b', [_vm._v("Category: ")]), _vm._v(_vm._s(_vm.category.business_category_name) + "\r\n                "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Products in " + _vm._s(_vm.category.business_category_name))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "display": "none",
      "padding": "0",
      "margin": "0",
      "float": "right",
      "margin-right": "1.3em"
    }
  }, [_c('div', {
    staticClass: "leftbtn",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('business', 'manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide"
  }, [_c('ul', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "-0.2em"
    }
  }, [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "viewBusinessCategory"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "manageBusinessCategory"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('p', {
    staticStyle: {
      "padding-top": "9px"
    }
  }, [_c('b', [_vm._v("Category: ")]), _vm._v(_vm._s(_vm.category.business_category_name))]), _vm._v(" "), _c('p', [(_vm.category.category_products) ? _c('span', [_vm._v("Total Products:" + _vm._s(_vm.category.category_products.length))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessCategory', '', '')
      }
    }
  }, [_vm._v("Products | ")])]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('manageBusinessCategory', '', '')
      }
    }
  }, [_vm._v("Settings | ")])]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.prepAddProduct()
      }
    }
  }, [_vm._v("Add New Product")])])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.businessComponentKey,
    staticClass: "row-after-stick"
  }, [(_vm.menu_tab_inner_view.viewBusinessCategory) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "0 0.1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_vm._m(1), _vm._v(" "), (_vm.category.category_products && (_vm.category.category_products.length != 0)) ? _c('div', _vm._l((_vm.category.category_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card p-card-fit-00"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square p-card-fit-01"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right p-card-fit-02 card-colord-01"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _c('div', [_c('p', [_vm._v("No products in this category")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.prepAddProduct()
      }
    }
  }, [_vm._v("Add New Product")])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.manageBusinessCategory) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('p', [_c('b', [_vm._v("Category Name: ")]), _vm._v(_vm._s(_vm.category.business_category_name))]), _vm._v(" "), (_vm.category.can_edit == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You can not edit this category name, it has a default setting")]) : _vm._e(), _vm._v(" "), (_vm.category.can_edit == 1) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-02-soft sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Rename "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.category.business_category))])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "display": "none",
      "margin-top": "1.5em"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.category.business_category_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02 sp-button-02-soft sp-button-sm",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Category Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_category', _vm.category.business_category_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "padding-top": "0em"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-soft sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deleteBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Delete Category")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.editBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('h6', [_vm._v("Rename " + _vm._s(_vm.category.business_category))]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('label', {}, [_vm._v("Enter category name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '');
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category);
      }
    }
  }, [_vm._v("Cancel "), _c('i', {
    staticClass: "fa fa-ban"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.deleteBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('p', [_vm._v("Do you want to Delete this Category and all products within it")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteCategory
    }
  }, [_vm._v("Yes,Request Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '');
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Cancel ")])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Category Image")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215abe58"}!./src/pages/Account/Sellpoint/Category/template.html
// module id = 517
// module chunks = 0